/**
 * pdp-gallery-swipe.js
 * Gallery swipe + dots for the phone-case and glass-ornament layouts of dopamiles-product-hero
 * (layout_mode: case / ornament). Small screens hide the thumb rail (assets/case-pdp.css), so the
 * main image gets a swipe and a row of dots. Both drive the existing thumb buttons, so
 * dopamiles-pdp.js stays the only code that switches slides.
 */
(function () {
  'use strict';

  var GALLERY = '.bnc-hero--case [data-bnc-gallery], .bnc-hero--ornament [data-bnc-gallery]';

  function initGallerySwipe(gallery) {
    if (gallery.dataset.caseSwipe === '1') return;
    var thumbs = Array.prototype.slice.call(gallery.querySelectorAll('[data-bnc-thumb]'));
    var main = gallery.querySelector('.bnc-gallery-main');
    if (thumbs.length < 2 || !main) return;
    gallery.dataset.caseSwipe = '1';

    var dots = document.createElement('div');
    dots.className = 'case-gallery-dots';
    thumbs.forEach(function (t, i) {
      var d = document.createElement('button');
      d.type = 'button';
      d.setAttribute('aria-label', 'Show image ' + (i + 1));
      d.addEventListener('click', function () { t.click(); });
      dots.appendChild(d);
    });
    main.insertAdjacentElement('afterend', dots);

    function current() {
      var i = thumbs.findIndex(function (t) { return t.classList.contains('active'); });
      return i < 0 ? 0 : i;
    }
    function markDots() {
      var i = current();
      Array.prototype.forEach.call(dots.children, function (d, j) {
        d.classList.toggle('is-on', j === i);
        d.setAttribute('aria-current', j === i ? 'true' : 'false');
      });
    }
    new MutationObserver(markDots).observe(gallery, { subtree: true, attributes: true, attributeFilter: ['class'] });
    markDots();

    var startX = null;
    var startY = null;
    main.addEventListener('touchstart', function (e) {
      startX = e.touches[0].clientX;
      startY = e.touches[0].clientY;
    }, { passive: true });
    main.addEventListener('touchend', function (e) {
      if (startX === null) return;
      var dx = e.changedTouches[0].clientX - startX;
      var dy = e.changedTouches[0].clientY - startY;
      startX = null;
      if (Math.abs(dx) < 40 || Math.abs(dx) < Math.abs(dy)) return;
      var next = (current() + (dx < 0 ? 1 : -1) + thumbs.length) % thumbs.length;
      thumbs[next].click();
    });
  }

  function boot() {
    document.querySelectorAll(GALLERY).forEach(initGallerySwipe);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  // Theme Editor re-renders the section after a settings change.
  document.addEventListener('shopify:section:load', boot);
})();
